// extracted by mini-css-extract-plugin
export const background = "DashboardTemplate-module--background--43TGt";
export const content = "DashboardTemplate-module--content--W_mJ3";